import type { C1_FurnitureDefinition } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";

const ExtractorHood: C1_FurnitureDefinition = {
  id: "extractorHood",
  icon: <C1_FurnitureIcon kind="extractor-hood" />,
  description: { en: "Extractor hood", de: "Dunstabzugshaube" },
  category: RoomType.Kitchen,
  defaultWidth: 0.6,
  defaultHeight: 0.5,
  autoRotate: true,
  autoReflect: true,
  grabsW: true,
  grabsH: true,
  properties: [],
  Renderer: ({width, height, rotation, PX, strokeWidth, strokeColor, fillColor, showDetails}) => {
    const color = strokeColor ?? "#000000";
    const lineWidth = strokeWidth ?? 2;
    const inset = Math.min(0.02 * PX, width * 0.1, height * 0.1);
    return (
      <C1_FurnitureSvg PX={PX} width={width} height={height} rotation={rotation ?? 0}
        viewBoxWidth={width} viewBoxHeight={height} originXPercentage={0} originYPercentage={0}>
        <rect x={inset} y={inset} width={width - 2 * inset} height={height - 2 * inset}
          rx={inset} fill={fillColor ?? "#ffffff"} stroke={color} strokeWidth={lineWidth * 2} />
        <rect x={width * 0.34} y={inset} width={width * 0.32} height={height * 0.28}
          fill="none" stroke={color} strokeWidth={lineWidth} />
        {showDetails && <g fill="none" stroke={color} strokeWidth={lineWidth}>
          <rect x={width * 0.12} y={height * 0.38} width={width * 0.76} height={height * 0.35} />
          {[0.25, 0.375, 0.5, 0.625, 0.75].map(x => <line key={x}
            x1={width * x} x2={width * x} y1={height * 0.38} y2={height * 0.73} />)}
          <circle cx={width * 0.2} cy={height * 0.85} r={Math.min(width, height) * 0.035} />
          <circle cx={width * 0.8} cy={height * 0.85} r={Math.min(width, height) * 0.035} />
        </g>}
      </C1_FurnitureSvg>
    );
  },
};

export default ExtractorHood;
